// dependencies
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { formatISO } from "date-fns";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { faCircleXmark, faCommentDots } from "@fortawesome/pro-regular-svg-icons";

// components
import Button from "../../../../../../../../../components/Button";
import Icon from "../../../../../../../../../components/Icon/Icon";
import Spacer from "../../../../../../../../../components/Spacer";
import Typography from "../../../../../../../../../components/Text";
import { TextEditor } from "../../../../../../../../../components/TextEditor";

// hooks
import { useGoalDetails, useGoalHistory, useMutatePostGoalHistory } from "../../../../../../../../../api/hooks";

import { Goal } from "../../../../../../../../../api/services";

// styles
import css from "./AddMessage.module.scss";

const AddMessage = () => {
	const { goal_id: goalId } = useParams<{ goal_id: string }>();
	const { data } = useGoalDetails({ goalID: goalId || "" });
	const goal = data ? data.goal : ({} as Goal);

	const { refetch: refetchActivity } = useGoalHistory({
		goalID: goalId || "",
		sortDirection: "desc",
		sortName: "_id",
	});
	const [message, setMessage] = useState("");
	const [isOpen, setIsOpen] = useState(false);
	const [valid, setValid] = useState(true);
	const [animationParent] = useAutoAnimate();
	const [animationValidationParent] = useAutoAnimate();

	const { mutate: addMessage, isPending } = useMutatePostGoalHistory({
		onSuccess: () => {
			setMessage("");
			refetchActivity();
			setIsOpen(false);
		},
	});

	useEffect(() => {
		setMessage("");
		setValid(true);
	}, [isOpen]);

	const onSubmit = () => {
		if (!message) {
			setValid(false);
		} else {
			addMessage({ goalID: goal?._id || "", data: { message, as_of: formatISO(new Date()) } });
			setValid(true);
		}
	};

	return (
		<div ref={animationParent} className={css.addMessageContainer}>
			<Button isHollow={true} onClick={() => setIsOpen(!isOpen)} className={css.toggleButton}>
				{isOpen ? (
					<div className={css.buttomMessage}>
						<Icon testid={faCircleXmark?.iconName} icon={faCircleXmark} size="small" />
						<Typography size="caption" weight="regular">
							Discard Message
						</Typography>
					</div>
				) : (
					<div className={css.buttomMessage}>
						<Icon icon={faCommentDots} size="small" />
						<Typography size="caption" weight="regular">
							Add Message
						</Typography>
					</div>
				)}
			</Button>
			<div>
				<Spacer height={1} />
			</div>
			{isOpen && (
				<form onSubmit={onSubmit} className={css.addMessageForm} ref={animationValidationParent}>
					<Typography size="paragraph-3" weight="semi-bold">
						Message
					</Typography>
					<div className={css.textEditorContainer}>
						<TextEditor
							initialValue=""
							isRichText={false}
							placeholder="Add Message"
							onChange={(value) => setMessage(value)}
							id="message-update goal progress"
							minHeight={88}
							className={css.textEditor}
							autoFocus
						/>
					</div>
					{!valid && (
						<Typography size="caption" color="red-6" weight="regular">
							Please enter a message
						</Typography>
					)}
					<Button onClick={onSubmit} isRequesting={isPending} color="blue" className={css.addMessageButton}>
						Submit
					</Button>
					<Spacer height={1} />
				</form>
			)}
		</div>
	);
};

export default AddMessage;
